import { app } from './app';
import { routes } from './routes';
import { services } from './services';

app.setRootState('site.landing-page');
app.run(routes, services);
